export const SocialStatusEnum = {
    ORPHAN_WITHOUT_GUARDIANSHIP: {id: 1, name: "Сирота без опеки"},
    ORPHAN_WITH_GUARDIANSHIP: {id: 2, name: "Сирота с опекой"},
    GROUP_ONE: {id: 3, name: "Инвалид по 1 группы"},
    FROM_CHILDHOOD: {id: 4, name: "Инвалиды с детства"}
}